export const consent = {
  title: 'Preparémonos para su consulta.',
  personalInformation: 'Información personal confirmada.',
  contactDetails: 'Datos de contacto confirmados.',
  submit: 'Siguiente',
  cancelVisitRequest: 'Cancelar ahora finalizará tu solicitud de visita.',
  completeSigning: 'Para continuar con tu visita, primero completa la firma del formulario de consentimiento.',
  successfullyCanceled: 'Tu visita ha sido cancelada con éxito.',
  actions: {
    returnToSign: 'Volver a firmar el consentimiento',
    cancelMyVisit: 'Cancelar mi visita',
    done: 'Listo',
  },
  errors: {
    failedToCancel: 'No se pudo cancelar la visita',
  },
};
